/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import { CategoryActions } from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

export const fetchCategoriesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CATEGORY_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, CategoryActions.receiveCategories))
);

export const createCategoryEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CATEGORY_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, CategoryActions.createdCategory))
);

export const updateCategoryEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CATEGORY_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, CategoryActions.updatedCategory))
);

export const deleteCategoryEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CATEGORY_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, CategoryActions.deletedCategory))
);
